/* eslint-disable max-lines-per-function */
/**
import function from '../sagas/sessionSagaApi';
 * Notary class.
 */
export class Notary {
  /**
   * Constructor for Notary class.
   *
   * @param {string} gender - The notary's gender.
   * @param {string} firstName - The notary's first name.
   * @param {string} name - The notary's name.
   * @param {string} birthDate - The notary's birth date.
   * @param {string} patentDate - The patent date of the notary.
   * @param {string} uid - A unique company uid.
   * @param {string} company - The company name.
   * @param {string} street - Street name of the company.
   * @param {string} streetNumber - Street number of the company.
   * @param {string} addition - An addition to the company address.
   * @param {string} postOffice - The post office of the company.
   * @param {string} postcode - The postcode of the company.
   * @param {string} location - The location of the company.
   * @param {string} careOf - The name of a responsible notary to care of.
   * @param {string} email - The notary's email address.
   * @param {string} phoneNumber - The notary's phone number.
   * @param {string} faxNumber - The notary's fax number.
   * @param {Object} certificate - The notary's certificate.
   * @param {number} applicationId - The application's unique id.
   * @param {string} status - The notary application status.
   * @param {array} functions - The funnctions of the notary.
   * @param {boolean} exportEmail - The export mail flag for upreg.
   * @param {boolean} signatureDeclarationDocument - The signature declaration flag.
   * @param {boolean} registrationDocument - The registration document flag.
   * @param {boolean} terminationDocument - The termination document flag.
   * @param {string} invoiceCompany - The company name (invoice).
   * @param {string} invoiceStreet - Street name of the company (invoice).
   * @param {string} invoiceStreetNumber - Street number of the company (invoice).
   * @param {string} invoicePostcode - The postcode of the company (invoice).
   * @param {string} invoiceLocation - The location of the company (invoice).
   * @param {string} mobileNumber - The notary's mobile number.
   */
  constructor(
    gender,
    firstName,
    name,
    birthDate,
    patentDate,
    uid,
    company,
    street,
    streetNumber,
    addition,
    postOffice,
    postcode,
    location,
    careOf,
    email,
    phoneNumber,
    faxNumber,
    certificate,
    applicationId = null,
    status = null,
    functions = null,
    exportEmail = null,
    signatureDeclarationDocument = null,
    registrationDocument = null,
    terminationDocument = null,
    invoiceCompany = null,
    invoiceStreet = null,
    invoiceStreetNumber = null,
    invoicePostcode = null,
    invoiceLocation = null,
    mobileNumber
  ) {
    this.gender = gender;
    this.firstName = firstName;
    this.name = name;
    this.birthDate = birthDate;
    this.patentDate = patentDate;
    this.uid = uid;
    this.company = company;
    this.street = street;
    this.streetNumber = streetNumber;
    this.addition = addition;
    this.postOffice = postOffice;
    this.postcode = postcode;
    this.location = location;
    this.careOf = careOf;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.faxNumber = faxNumber;
    this.certificate = certificate;
    this.id = applicationId;
    this.status = status;
    this.functions = functions;
    this.exportEmail = exportEmail;
    this.signatureDeclarationDocument = signatureDeclarationDocument;
    this.registrationDocument = registrationDocument;
    this.terminationDocument = terminationDocument;
    this.invoiceCompany = invoiceCompany;
    this.invoiceStreet = invoiceStreet;
    this.invoiceStreetNumber = invoiceStreetNumber;
    this.invoicePostcode = invoicePostcode;
    this.invoiceLocation = invoiceLocation;
    this.mobileNumber = mobileNumber;
  }
}
